import * as yup from 'yup'
import { ERROR_MESSAGE } from 'utils/globalConstant'

export const validationSchema = yup.object({
    company_name: yup.string().required(ERROR_MESSAGE.required),
    domain_name: yup.string().required(ERROR_MESSAGE.required),
})
